import JobViewPage from './view'
export default JobViewPage
